module.exports = __webpack_public_path__ + "img/cart1.17d5b695.jpg";